import * as React from 'react'
import { styled } from '@mui/material/styles';

const ApexChart = React.lazy(() => import('react-apexcharts'), {
    ssr: false,
    loading: () => null
});

export const Chart = styled(ApexChart)``;